module.exports = __webpack_public_path__ + "static/media/p5.45ef4e57.png";